import React from "react";

import SearchIcon from "../../icons/search-icon";

import lbl from "../../data/Labels.json";

const TableMainSearch = ({ setQuery }) => {
  const handleSubmit = (e) => {
    e.preventDefault();

    setQuery && setQuery(e.target.query.value);
  };

  return (
    <React.Fragment>
      <form className="keyword" onSubmit={handleSubmit}>
        <div className="search-input">
          <input
            className="parity-search-input"
            placeholder={lbl.Search}
            aria-label={lbl.Search}
            maxLength={32}
            name="query"
            type="search"
          />
          <button type="submit" aria-label={lbl.Search}>
            <SearchIcon />
          </button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default TableMainSearch;
